import React from 'react';

const Merchants = ({ lang, t }) => {
  const isRtl = lang === 'ar';

  const merchants = [
    {
      id: 1,
      role: isRtl ? "تاجر جملة" : "Wholesale Merchant",
      location: isRtl ? "القاهرة الكبرى" : "Greater Cairo",
      text: isRtl 
        ? "بصفتي تاجر جملة، ما يهمني هو ثبات التركيز في كل شحنة. منتجات يام تعطيني الأمان أمام زبائني لأن جودتها لا تتغير، وهذا سر استمرارنا معهم."
        : "As a wholesaler, what matters most is consistency. YAM products give me confidence with my customers because the quality never fluctuates.",
      stars: 5
    },
    {
      id: 2,
      role: isRtl ? "موزع كيماويات معتمد" : "Certified Distributor",
      location: isRtl ? "محافظات الدلتا" : "Delta Region",
      text: isRtl 
        ? "التغليف الممتاز وسرعة التوريد هي ما تجعلني أفضل يام. الطلبيات تصل في موعدها وبحالة ممتازة، مما يسهل عليّ عمليات التوزيع والبيع السريع."
        : "Excellent packaging and fast supply are why I prefer YAM. Orders arrive on time and in perfect condition, facilitating my rapid sales operations.",
      stars: 5
    },
    {
      id: 3,
      role: isRtl ? "صاحب مركز توريدات" : "Supply Center Owner",
      location: isRtl ? "جنوب مصر" : "Upper Egypt",
      text: isRtl 
        ? "أتعامل مع يام منذ سنوات كتاجر، ومنتجاتهم مطلوبة بالاسم في السوق. هامش الربح والطلب المرتفع على خاماتهم جعلهم الشريك الأساسي في نجاح مركزي."
        : "I have dealt with YAM for years. Their products are requested by name. The high profit margin and demand made them my primary success partner.",
      stars: 5
    }
  ];

  return (
    <section id="merchants" className="merch-section">
      <div className="container-limited">
        <div className="merch-header">
          <h2 className="merch-title">
            {isRtl ? 'ثقة ' : 'Trusted by '}
            <span className="gold-text">{isRtl ? 'كبار التجار' : 'Leading Merchants'}</span>
          </h2>
          <div className="merch-line"></div>
        </div>

        <div className="merch-grid">
          {merchants.map((m) => (
            <div key={m.id} className="merch-card">
              <div className="quote-icon">“</div>
              <p className="merch-text">{m.text}</p>
              
              <div className="stars">
                {"★".repeat(m.stars)}
              </div>
              
              <div className="merch-footer">
                <div className="merch-info">
                  <span className="merch-role">{m.role}</span>
                  <span className="merch-loc"> • {m.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .merch-section {
          padding: 100px 0;
          background-color: #0d1f33;
          color: white;
        }

        .merch-header {
          text-align: center;
          margin-bottom: 70px;
        }

        /* تكبير العنوان الرئيسي */
        .merch-title {
          font-size: clamp(2.2rem, 5vw, 3.5rem);
          font-weight: 900;
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .gold-text { color: #d4af37; }

        .merch-line {
          width: 100px;
          height: 6px;
          background: #d4af37;
          margin: 0 auto;
          border-radius: 10px;
        }

        .merch-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 40px;
          direction: ${isRtl ? 'rtl' : 'ltr'};
          padding: 0 20px;
        }

        .merch-card {
          background: rgba(255, 255, 255, 0.04);
          padding: 60px 40px 45px;
          border-radius: 25px;
          border: 1px solid rgba(212, 175, 55, 0.2);
          position: relative;
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
          display: flex;
          flex-direction: column;
        }

        .merch-card:hover {
          transform: translateY(-15px);
          border-color: #d4af37;
          background: rgba(255, 255, 255, 0.08);
          box-shadow: 0 20px 40px rgba(0,0,0,0.3);
        }

        .quote-icon {
          position: absolute;
          top: 10px;
          ${isRtl ? 'left: 25px;' : 'right: 25px;'}
          font-size: 6rem;
          color: rgba(212, 175, 55, 0.15);
          font-family: serif;
          line-height: 1;
        }

        /* تكبير نصوص التجار الاستشهادية */
        .merch-text {
          font-size: clamp(1.15rem, 1.5vw, 1.3rem);
          line-height: 1.8;
          color: #e2e8f0;
          margin-bottom: 30px;
          position: relative;
          z-index: 1;
          flex-grow: 1;
          font-weight: 600; /* وزن أثقل للخط */
          font-style: italic;
        }

        .stars {
          color: #d4af37;
          margin-bottom: 25px;
          font-size: 1.2rem;
          letter-spacing: 3px;
        }

        .merch-footer {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding-top: 25px;
        }

        /* تكبير معلومات التاجر في الأسفل */
        .merch-info {
          font-size: 1.1rem;
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .merch-role {
          color: #d4af37;
          font-weight: 800;
          text-transform: uppercase;
        }

        .merch-loc {
          color: #94a3b8;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .merch-grid { grid-template-columns: 1fr; }
          .merch-title { font-size: 2.2rem; }
          .merch-card { padding: 50px 30px 35px; }
          .merch-text { font-size: 1.1rem; }
        }
      `}</style>
    </section>
  );
};

export default Merchants;